import axios from "axios";

const { REACT_APP_VEHICLES_API } = process.env;

const { CancelToken } = axios;
const source = CancelToken.source();

export const getVehicleGroups = async (
  customer,
  cancelToken = source.token,
  page: number = 1,
  orderBy = "name",
  order = "asc",
  query = "",
  vehiclesOnly: boolean = false,
  expandVehicles: boolean = false,
  resultsPerPage: number = 30,
  filterBy = "",
) => {
  const url = `page=${page}&order_by=${orderBy}&order=${order}&q=${query}&vehicles_only=${vehiclesOnly}&expand_vehicles=${expandVehicles}&results_per_page=${resultsPerPage}`;
  const params = new URLSearchParams(url);
  if (filterBy) {
    params.set("filters", filterBy);
  }
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_groups?${params.toString()}`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const getVehicleGroup = async (customer, vehicleGroupId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_groups/${vehicleGroupId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const createVehicleGroup = async (customer, name, users, vehicles) => {
  try {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("token"))
      ?.split("=")[1];
    const res = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_groups`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        name,
        users,
        vehicles,
      },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const updateVehicleGroup = async (
  customer,
  vehicleGroupId,
  name,
  users,
  vehicles,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "put",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_groups/${vehicleGroupId}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        name,
        users,
        vehicles,
      },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const deleteVehicleGroup = async (customer, vehicleGroupId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_groups/${vehicleGroupId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const getVehicleGroupsByUser = async (
  customer: string,
  userId: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/users/${userId}/vehicle_groups`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const addVehicleGroupToUser = async (
  customer: string,
  vehicleGroupId: string,
  userId: string,
  data: { edit_vehicle: boolean; create_reservation: boolean },
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_groups/${vehicleGroupId}/users/${userId}`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return { data: res.data.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};


export const addVehicleGroupToUserBulk = async (customer: string, userId: string, data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/${customer}/users/${userId}/vehicle_groups`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return { data: res.data.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};


export const updateVehicleGroupToUser = async (
  customer: string,
  vehicleGroupId: string,
  userId: string,
  data: { edit_vehicle: boolean; create_reservation: boolean },
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "put",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_groups/${vehicleGroupId}/users/${userId}`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return { data: res.data.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const removeVehicleGroupFromUser = async (
  customer: string,
  vehicleGroupId: string,
  userId: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_groups/${vehicleGroupId}/users/${userId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};
